/*
 * PDP interactions matrix option selectors to narrow down product to purchase
 */
(function ($) {
    var selectors = {
        errorMessage: '.js-selection-error',
        matrices: '.js-selection-matrix',
        matrixOptions: '.js-selection-matrix-option',
        matrixOptionButtons: '.js-selection-matrix-option-container',
        selectedDescription: '.js-selection-description'
    };

    //helper method to retrieve the intersect of two array sets
    //if either array is undefined, method returns other array (or empty array)
    function intersect(a, b) {
        if (!a || !a.length) {
            return b || [];
        }
        else if (!b || !b.length) {
            return a;
        }
        var r = [], o = {}, l = b.length, i, v;
        for (i = 0; i < l; i++) {
            o[b[i]] = true;
        }
        l = a.length;
        for (i = 0; i < l; i++) {
            v = a[i];
            if (v in o) {
                r.push(v);
            }
        }
        return r;
    }

    //helper method that merges one or more arrays
    //by combining all values and removing duplicates
    function merge() {
        var args = arguments;
        var hash = {};
        var arr = [];
        for (var i = 0; i < args.length; i++) {
            for (var j = 0; j < args[i].length; j++) {
                if (hash[args[i][j]] !== true) {
                    arr[arr.length] = args[i][j];
                    hash[args[i][j]] = true;
                }
            }
        }
        return arr;
    }

    $.fn.matrixSelectors = function (args) {
        var $container = this,
            options = $.extend({
                items: {},
                selectionUpdated: $.noop
            }, args),
            $allMatrixOptions = $container.find(selectors.matrixOptions).filter('[data-itemids!=""]'),
            $allMatrices = $container.find(selectors.matrices);

        //initialize each matrix with the product id of its options
        $.each($allMatrices, function (i, matrix) {
            var $matrix = $(matrix);

            $matrix.data('product-id', $matrix.find(selectors.matrixOptions).data('product-id'));
        });

        //build a dictionary of product id -> item ids to be used throughout logic
        var itemIdsByProductId = {},
            skuRegex = new RegExp('[A-Z]{2}-(\\d{4,})-\\d{4}', 'i');
        $.each(options.items, function (itemId, item) {
            item.ProductId = parseInt(skuRegex.exec(item.SKU)[1]);
            if (itemIdsByProductId.hasOwnProperty(item.ProductId)) {
                itemIdsByProductId[item.ProductId].push(itemId);
            } else {
                itemIdsByProductId[item.ProductId] = [itemId];
            }
        });

        //helper method that gets all the checked options
        function getSelectedOptions() {
            return $allMatrixOptions.filter(':checked');
        }

        //helper method that will get all the sibling input tags to the given matrix option
        function getSiblingsOfOption($option) {
            return $option.closest(selectors.matrices).find(selectors.matrixOptions).not($option);
        }

        //helper method that gets all the unique item ids found in the matrix options given
        function getUniqueItemIds($matrixOptions) {
            var selectedItemIdsByProductId = {};

            if ($matrixOptions && $matrixOptions.length) {
                $matrixOptions.each(function () {
                    var $this = $(this),
                        productId = $this.data('product-id'),
                        itemIds = ($this.attr('data-itemids') || '').split(',');
                    selectedItemIdsByProductId[productId] = intersect(selectedItemIdsByProductId[productId], itemIds);
                });
            }

            return $.extend({}, itemIdsByProductId, selectedItemIdsByProductId);
        }

        //helper method that updates the selection display for a matrix given the newly selected option
        //i.e. Select Size: [new size here]
        function updateMatrixSelection($selectedMatrixOption, $relativeMatrixOption) {
            if (!$relativeMatrixOption) {
                $relativeMatrixOption = $selectedMatrixOption;
            }

            var $matrix = $relativeMatrixOption.closest(selectors.matrices),
                $selectedDescription = $matrix.find(selectors.selectedDescription),
                selectionDisplay = $selectedMatrixOption.val() || '';

            if ($selectedMatrixOption.data('disable-reason')) {
                selectionDisplay += ' - ' + $selectedMatrixOption.data('disable-reason');
            }

            $(selectors.errorMessage).hide();
            $selectedDescription.html(selectionDisplay);
        }

        // helper method to hide / show elements based on the current selection
        function updateConditionalDisplay(groupName) {
            var selectedOption = null,
                enabledOptions = [],
                disabledOptions = [];
            $allMatrixOptions.filter('[name="' + groupName + '"]').each(function () {
                var $this = $(this),
                    thisValue = ($this.val() || '').toLowerCase().replace(/"/g, '\\"'),
                    thisDisplayKey = groupName.toLowerCase() + '-' + thisValue;

                if ($this.is(':checked')) {
                    selectedOption = thisDisplayKey;
                } else if ($this.is(':enabled')) {
                    enabledOptions.push(thisDisplayKey);
                } else {
                    disabledOptions.push(thisDisplayKey);
                }
            });

            var optionsToShow = [],
                optionsToHide = [];

            if (selectedOption) {
                optionsToShow.push(selectedOption);
                optionsToHide = $.merge(enabledOptions, disabledOptions);
            } else if (disabledOptions.length) {
                optionsToShow = enabledOptions;
                optionsToHide = disabledOptions;
            }

            $($.map(optionsToShow, function (key) { return '[data-show="' + key + '"]'; }).join(',')).show();
            $($.map(optionsToShow, function (key) { return '[data-required="' + key + '"]'; }).join(',')).prop('required', true);
            $($.map(optionsToHide, function (key) { return '[data-show="' + key + '"]'; }).join(',')).hide().find(':checked').each(function () {
                var $this = $(this);

                //disable the custom amount box for gift card price if it's currently checked (and now hidden)
                setTimeout(function () {
                    $this.val('').prop('checked', false);
                    $this.trigger('matrixoptionchanged.evo');
                    updateMatrixSelection($this);
                }, 350);
            });
            $($.map(optionsToHide, function (key) { return '[data-required="' + key + '"]'; }).join(',')).prop('required', false);
        }

        //helper method that updates the page display based on the item(s) that are currently selected via
        //the options. This will update the displayed price and marketing price based on the item ids passed in
        function updateSelectedItemsDisplay(eventType, $selectedOptions, $originator) {
            var uniqueItemIdsByProductId = getUniqueItemIds($selectedOptions);

            if ($selectedOptions) {
                //enable the options that are available with the currently selected item(s)
                //and disabled the options that are not
                //what basically needs to happen is that we loop through each matrix, get the selected options
                //in the other matrices and disable/enable the options inside
                $allMatrices.each(function () {
                    var $matrix = $(this),
                        matrixProductId = $matrix.data('product-id'),
                        matrixSelector = ('.js-matrixtype-' + $matrix.attr('data-matrixtype')).replace('&','\\&'),
                        $theseOptions = $allMatrixOptions.filter(matrixSelector),
                        $otherSelectedOptions = $selectedOptions.not(matrixSelector),
                        otherUniqueItemIdsByProductId = getUniqueItemIds($otherSelectedOptions),
                        matrixOptionSelector = '';

                    $.each(otherUniqueItemIdsByProductId, function (productId, itemIds) {
                        if (matrixProductId != productId) {
                            return;
                        }
                        var productIdSelector = '.js-selection-product-id-' + productId + '._';
                        matrixOptionSelector += productIdSelector + itemIds.join(',' + productIdSelector)
                    });

                    matrixOptionSelector = matrixOptionSelector || '*';

                    var optionsNeedEnabling = $theseOptions.filter(matrixOptionSelector).filter(':disabled');
                    optionsNeedEnabling.prop('disabled', false);
                    var optionsNeedDisabling = $theseOptions.not(matrixOptionSelector).filter(':enabled');
                    optionsNeedDisabling.prop('disabled', true);

                    //hide/show elements based on data attributes
                    //get a list of unique matrices that were modified
                    var names = optionsNeedDisabling.add(optionsNeedEnabling).map(function () { return $(this).attr('name'); }).get();
                    if ($originator) {
                        names.push($originator.attr('name'));
                    }
                    names = names.filter(function (v, i, s) { return v && s.indexOf(v) === i; });

                    for (var i = 0; i < names.length; i++) {
                        updateConditionalDisplay(names[i]);
                    }
                });
            }

            //calculate the aggregate of the selected items using the itemInfo lookup
            var selectedItemIds = [],
                components = [];
            $.each(uniqueItemIdsByProductId, function (productId, itemIds) {
                selectedItemIds = selectedItemIds.concat(itemIds);

                var component = {
                    availability: 0,
                    displayType: Number.MAX_VALUE,
                    estimatedShipDate: new Date(8640000000000000), //max date value
                    eventType: eventType,
                    isInCollection: false,
                    minPrice: Number.MAX_VALUE,
                    maxPrice: Number.MIN_VALUE,
                    minMarketingPrice: Number.MAX_VALUE,
                    maxMarketingPrice: Number.MIN_VALUE,
                    minPriceStatus: 3, //(not set)
                    maxPriceStatus: 0 //(not set)
                };
                for (i = 0; i < itemIds.length; i++) {
                    var item = options.items[itemIds[i]];
                    if (!item) {
                        continue;
                    }
                    component.availability |= item.Availability;
                    component.displayType = Math.min(item.DisplayType, component.displayType);
                    if (component.estimatedShipDate !== null) {
                        var estimatedShipDate = item.EstimatedShipDate ? new Date(item.EstimatedShipDate + 'Z') : null;
                        if (component.estimatedShipDate > estimatedShipDate) {
                            component.estimatedShipDate = estimatedShipDate;
                        }
                    }
                    component.isInCollection = component.isInCollection || item.IsInCollection;
                    if (item.Price < component.minPrice) {
                        component.minPrice = item.Price;
                        component.minPriceStatus = item.PriceStatus;
                    }
                    if (item.Price > component.maxPrice) {
                        component.maxPrice = item.Price;
                        component.maxPriceStatus = item.PriceStatus;
                    }
                    component.minMarketingPrice = Math.min(item.MarketingPrice, component.minMarketingPrice);
                    component.maxMarketingPrice = Math.max(item.MarketingPrice, component.maxMarketingPrice);
                }

                //in-stock and pre-order should not be possible within a component
                //in-stock trumps
                if ((component.availability & 5) === 5) {
                    component.availability &= 3;
                }

                components.push(component);
            });

            var finalResult = components[0] || {
                availability: 0,
                displayType: Number.MAX_VALUE,
                estimatedShipDate: null,
                eventType: eventType,
                isInCollection: false,
                minPrice: Number.MAX_VALUE,
                maxPrice: Number.MIN_VALUE,
                minPriceStatus: 1,
                maxPriceStatus: 1,
                minMarketingPrice: Number.MAX_VALUE,
                maxMarketingPrice: Number.MIN_VALUE
            },
                //list of price statuses in order of display-importance
                //(Full < Sale < Clearance < Final Sale < Limited Time)
                priceStatusOrder = [1, 2, 4, 5, 3];
            finalResult.itemIds = selectedItemIds;

            //in the case of mashups, merge the properties across components that we care about (most are overridden in buy grid code)
            $.each(components, function (i, component) {
                if (i === 0) {
                    return;
                }
                finalResult.availability |= component.availability;
                if (component.estimatedShipDate) {
                    finalResult.estimatedShipDate = !!finalResult.estimatedShipDate || finalResult.estimatedShipDate < component.estimatedShipDate
                        ? component.estimatedShipDate
                        : finalResult.estimatedShipDate;
                }

                //in-stock and pre-order should not be possible for a mashup
                //pre-order trumps since this is across components
                if ((finalResult.availability & 5) === 5) {
                    finalResult.availability &= 4;
                }

                finalResult.minMarketingPrice += component.minMarketingPrice;
                finalResult.maxMarketingPrice += component.maxMarketingPrice;

                if (priceStatusOrder.indexOf(component.minPriceStatus) > priceStatusOrder.indexOf(finalResult.minPriceStatus)) {
                    finalResult.minPriceStatus = component.minPriceStatus;
                }
                if (priceStatusOrder.indexOf(component.maxPriceStatus) > priceStatusOrder.indexOf(finalResult.maxPriceStatus)) {
                    finalResult.maxPriceStatus = component.maxPriceStatus;
                }
            });

            options.selectionUpdated(finalResult);
        }

        //handler for matrix option change event
        //whenever an item gets clicked on, we need to grab all of the selected items
        //and update the page display
        $allMatrixOptions.on('change', function () {
            var $this = $(this);

            //fire event to update hero and alt images if this button has an image
            $this.trigger('matrixoptionchanged.evo');

            //update the "Select Size/Color" selection display
            updateMatrixSelection($this);

            //update the pricing display based on the currently selected items
            updateSelectedItemsDisplay('change', getSelectedOptions(), $this);
        });

        var $matrixOptionButtons = $(selectors.matrixOptionButtons);

        //handler for mouseenter/mouseleave events
        //mouseenter should update page display with the hovered item trumping any siblings
        //mouseleave should update page display with everything reverted to how it was before the hover
        //use touchend for touch devices because we don't have a mouseleave
        var hoverEvent = Modernizr.touch ? 'touchend' : 'mouseenter mouseleave';
        $matrixOptionButtons.on(hoverEvent, function (e) {
            var $this = $(this).find(selectors.matrixOptions);

            if ($this.is(':checked')) {
                //remove the checked on touch end after a timeout because the change event seems to happen after this fires.
                if (Modernizr.touch) {
                    setTimeout(function () {
                        $this.prop('checked', false);
                        updateSelectedItemsDisplay('change', getSelectedOptions(), $this);
                    }, 350);
                }
                return;
            }

            var selectedItems = getSelectedOptions();
            var $selectedSibling = getSiblingsOfOption($this).filter(':checked');

            if (e.type === 'mouseenter') {
                selectedItems = selectedItems.not($selectedSibling).add($this);
                updateMatrixSelection($this);
            } else {
                updateMatrixSelection($selectedSibling, $this);
            }

            if (!$this.is(':disabled')) {
                updateSelectedItemsDisplay(e.type, selectedItems, $this);
            }
        });

        //handler for option mouseup event
        //if the option is selected, this should de-select the user's option
        //so that they can undo a selection
        //don't do this for touch devices. it's handled above
        if (!Modernizr.touch) {
            $matrixOptionButtons.on('mouseup', function (e) {
                var $this = $(this).find(selectors.matrixOptions);
                if ($this.is(':checked')) {
                    setTimeout(function () {
                        $this.prop('checked', false);
                        updateSelectedItemsDisplay('change', getSelectedOptions(), $this);
                    }, 100);
                }
            });
        }

        $(function () {
            //init code for matrices that have only one option to select (auto-select it)
            $allMatrices.each(function () {
                var availableOptions = $(this).find(selectors.matrixOptions).filter('[data-itemids!=""]');

                if (availableOptions.size() === 1) {
                    availableOptions.prop('checked', true).trigger('change');
                }
            });

            //make sure the options have been updated
            //this is also here to ensure that products without options can be purchased
            updateSelectedItemsDisplay('change', getSelectedOptions());
        });

        return this;
    };
})(jQuery);